import { PetInfo } from '@app/core/models';
import { selectConsultationRenalDetectRecommendation } from '@app/store/consultation/consultation.selectors';
import { selectBreeds } from '@app/store/core';
import { selectProfile, selectWeight } from '@app/store/patient-profile/patient-profile.selectors';
import { createSelector } from '@ngrx/store';

/**
 * Deprecated pet info selector for old components compatibilty
 */
export const selectRapidRecoPetSummary = createSelector(
  selectProfile,
  selectWeight,
  selectConsultationRenalDetectRecommendation,
  selectBreeds,
  (profile, weight, renalDetectRecommendation, breeds) => {
    return (
      !!profile &&
      <PetInfo>{
        ...profile,
        breedObject: breeds?.find((b) => b.breedCode === profile.breed),
        bcs: weight?.bcs,
        weight: weight?.currentWeight,
        targetWeight: weight?.targetWeight,
        // IBW: getIbwFromBcsAndLifeStage(weight, profile),
        petActivity: weight?.petActivity,
        pathologies: renalDetectRecommendation?.pathologies || [],
        sensitivities: [],
      }
    );
  },
);
